import React from 'react';
import styles from './WheelTaskItem.module.scss';
import { useNavigate } from 'react-router-dom';
import { useNotificationStore } from '@/store/NotificationStore';
import WebApp from '@twa-dev/sdk';

const WheelTaskItem = ({ task }: { task: any }) => {
  const navigate = useNavigate();
  const current = task.user_progress ?? 0;
  const total = task.target_progress ?? 1;
  const percent = Math.min(100, Math.max(0, (current / total) * 100));
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );

  const handleFriendsTask = () => {
    setNotification({
      type: 'Success',
      message: 'Ссылка успешно скопирована',
    });
    navigator.clipboard.writeText(task.details.ref_link);
    if (WebApp.HapticFeedback?.notificationOccurred) {
      WebApp.HapticFeedback.notificationOccurred('success');
    }
  };
  if (task.type !== 'complete-tasks') {
    return (
      <div className={styles.wheelTaskItem}>
        <div className={styles.progressWrapper}>
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `${percent}%` }}
            />
          </div>
          <div className={styles.progressText}>
            {current}/{total}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>{task.view_details.title}</div>

          {task.status === 'claim' ? (
            <div className={styles.done}>Выполнено ✓</div>
          ) : (
            <button onClick={handleFriendsTask} className={styles.button}>
              Скопировать
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wheelTaskItem}>
      <div className={styles.progressWrapper}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${percent}%` }}
          />
        </div>
        <div className={styles.progressText}>
          {current}/{total}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{task.view_details.title}</div>
        {task.status === 'claim' ? (
          <div className={styles.done}>Выполнено ✓</div>
        ) : (
          <button
            onClick={() => {
              navigate(`/tasks`);
            }}
            className={styles.button}
          >
            Перейти
          </button>
        )}
      </div>
    </div>
  );
};

export default WheelTaskItem;
